export const commonWords = new Set([
  'a',
  'an',
  'as',
  'is',
  'if',
  'of',
  'the',
  'it',
  'its',
  'or',
  'are',
  'this',
  'with',
  'so',
  'to',
  'at',
  'was',
  'and',
]);

export const inappropriateEmojis = [
  '🍆',
  '💦',
  '🍑',
  '🌮',
  '👅',
  '🐍',
  '🔯',
  '🖕',
  '🚬',
  '💣',
  '🔫',
  '🔪',
  '💊',
  '💉',
];
